import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Router } from '@angular/router';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'


//constants
import { Constants } from '../../constants/Constants';

//components
import { BaseRequestComponent } from '../../baseclasses/BaseRequest.component';
import { UserInfoComponent } from '../../components/ControlGroups/UserInfo.component';
import { CompletionDetailsComponent } from '../../components/ControlGroups/CompletionDetails.component';
import { RequestHeaderComponent } from '../../components/Controls/RequestHeader.component';
import { ChangePhoneNumberDialogComponent } from '../../components/Employees/ChangePhoneNumberDialog.component';
import { GeneralDetailsComponent } from '../ControlGroups/GeneralDetails.component';
import { BillingDiscrepancyDetailsComponent } from '../ControlGroups/BillingDiscrepancyDetails.component';
import { SupportRequiredDetailsComponent } from '../ControlGroups/SupportRequiredDetails.component';
import { NotesComponent } from '../../components/ControlGroups/Notes.component';

@Component({
    selector: 'my-create-billing-discrepancy-request',
    templateUrl: './CreateBillingDiscrepancyRequest.component.html',
    providers: [{ provide: BaseRequestComponent, useExisting: forwardRef(() => CreateBillingDiscrepancyRequestComponent) }]
})
export class CreateBillingDiscrepancyRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(BillingDiscrepancyDetailsComponent) billingDiscrepancyDetailsComponent: BillingDiscrepancyDetailsComponent;
    @ViewChild(SupportRequiredDetailsComponent) supportRequiredDetailsComponent: SupportRequiredDetailsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;

    constructor() {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus()) {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();


    }

    onSaveClick(event: any) {

        this.requestToSave = {
            ID: this.requestID,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            OtherInfo: this.notesComponent.otherInfo,
            BillingDiscrepancyInfo: this.billingDiscrepancyDetailsComponent.billingDiscrepancyInfo,
            SupportRequiredInfo: this.supportRequiredDetailsComponent.supportRequiredInfo,
            RequestTypeID: enums.RequestTypeEnum.BillingDiscrepancy,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID,
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID,
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);


        if (this.userInfoComponent.request.PhoneNumber) {
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }


        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }
    onYes(event: ent.Response) {
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any) {
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any) {
        //do nothing
    }

    requestTypeChanged(requestTypeID: number) {
        this.supportRequiredDetailsComponent.handleRequestType(requestTypeID);
    }

}